import { ISetorDafForm, ISetorDafRegistro } from '../../modules/types/SetorDaf';
import httpClient from '../httpClient';

const API_BASE = '/api/setores-daf';

/**
 * GET ALL
 */
export const getAllSetoresDaf = async (): Promise<ISetorDafRegistro[]> => {
  try {
    const response = await httpClient.get(API_BASE);

    const lista: ISetorDafRegistro[] = Array.isArray(response.data?.registros)
      ? response.data.registros
      : [];

    // Ordenação – você pode trocar se quiser por sigla ou id
    return lista.sort((a, b) => a.nomeSetorDaf.localeCompare(b.nomeSetorDaf));
  } catch (error: any) {
    throw new Error('Erro ao obter lista de Setores DAF: ' + error.message);
  }
};

/**
 * GET BY ID
 */
export const getSetorDafById = async (
  id: string | number,
): Promise<ISetorDafRegistro> => {
  try {
    const response = await httpClient.get(`${API_BASE}/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao obter Setor DAF: ' + error.message);
  }
};

/**
 * CREATE
 */
export const handleCreateSetorDaf = async (
  form: ISetorDafForm,
): Promise<any> => {
  try {
    const response = await httpClient.post(API_BASE, form);
    return response.data; // { message, registro }
  } catch (error: any) {
    throw new Error('Erro ao criar Setor DAF: ' + error.message);
  }
};

/**
 * UPDATE
 */
export const handleUpdateSetorDaf = async (
  form: ISetorDafForm,
): Promise<any> => {
  try {
    const response = await httpClient.patch(`${API_BASE}/${form.id}`, form);
    return response.data; // { message, registro }
  } catch (error: any) {
    throw new Error('Erro ao atualizar Setor DAF: ' + error.message);
  }
};

/**
 * DELETE (soft delete)
 */
export const handleDeleteSetorDaf = async (
  id: string | number,
): Promise<any> => {
  try {
    const response = await httpClient.delete(`${API_BASE}/${id}`);
    return response.data; // { message }
  } catch (error: any) {
    throw new Error('Erro ao excluir Setor DAF: ' + error.message);
  }
};
